export const initialState = {
    name: '',
    regionID: '',
    protocol: 0, // Default protocol value
    uri: '',
    proxy: '',
    registrationDuration: 3600, // Default to 3600 seconds (1 hour)
    username: '',
    password: '',
};

export const ownershipLabels = {
    20: 'Company',
    40: 'Partner',
};

export const registrarsPath = '/pbx';

export const breadCrumbTrail = [
    { label: 'Resources', path: '' },
    { label: 'Registrar Management', path: registrarsPath },
    { label: 'Add Registrar', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Resources', path: '' },
    { label: 'Registrar Management', path: registrarsPath },
    { label: 'Edit Registrar', path: '' },
];

export const addHeader = 'Registrar Details';
export const editHeader = 'Registrar Details';

export const ERROR_MESSAGES = {
    NAME_REQUIRED: 'Registrar name is required',
    REGION_REQUIRED: 'Region is required',
    URI_REQUIRED: 'URI is required',
    PROXY_REQUIRED: 'Proxy is required',
    REGISTRATION_DURATION_REQUIRED: 'Registration duration is required',
    USERNAME_REQUIRED: 'Username is required',
    PASSWORD_REQUIRED: 'Password is required',
    REGISTRAR_NAME_REQUIRED:
        'Registrar name is required and must be at least 2 characters',
    REGISTRATION_DURATION_INVALID:
        'Registration duration must be a positive number',
};

// Protocol enum for TRS registrars (assuming SIP = 0)
export const PROTOCOL = {
    DEFAULT: 0,
    UDP: 1,
    TCP: 2,
    TLS: 4,
};

export const protocolOptions = [
    { value: PROTOCOL.DEFAULT, label: 'Default' },
    { value: PROTOCOL.UDP, label: 'UDP' },
    { value: PROTOCOL.TCP, label: 'TCP' },
    { value: PROTOCOL.TLS, label: 'TLS' },
];

export const popoverStyles = {
    '& button + div': {
        zIndex: 10,
    },
};

// Ownership mapping based on scope
export const OWNERSHIP_MAPPING = {
    Company: 20,
    Partner: 40,
};

// Helper function to format registration duration
export const formatRegistrationDuration = (seconds) => {
    if (!seconds) return 'N/A';

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    if (hours > 0) {
        if (minutes > 0) {
            return `${hours}h ${minutes}m`;
        }
        return `${hours}h`;
    } else if (minutes > 0) {
        if (remainingSeconds > 0) {
            return `${minutes}m ${remainingSeconds}s`;
        }
        return `${minutes}m`;
    }
    return `${seconds}s`;
};
